import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { AlertTriangle } from 'lucide-react'

export function UnsupportedTaskFallback({ taskType }: { taskType: string }) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-solid border-gray-100 p-6 text-center">
      <AlertTriangle size={32} className="text-gray-80" />
      <div className="flex flex-col gap-1">
        <Text type="subtitle-semibold">
          <Trans>Unsupported task type</Trans>
        </Text>
        <Text type="body2-regular" className="text-gray-80">
          <Trans>
            This task requires type <code className="rounded bg-gray-100 px-1.5 py-0.5 font-mono text-xs">{taskType}</code>{' '}
            which is not yet supported.
          </Trans>
        </Text>
      </div>
    </div>
  )
}
